import React from 'react';
import './HeroCta.css';

export function HeroCta() {
  return (
    <div className="hero-cta">
      <a href="mailto:aimus1440@gmail.com" className="hero-cta__button">
        서비스 문의하기
      </a>
    </div>
  );
}
